var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({
    position: 'fixed',
    width: _vm.svgWidth,
    height: _vm.svgHeight,
    'pointer-events': 'none',
    zIndex: 2,
    top: _vm.mouseY,
    left: _vm.svgLeft,
  }),attrs:{"id":"svg-safe-area"}},[_c('path',{staticClass:"path1",attrs:{"pointer-events":"none","width":"100%","height":"100%","d":`M 0,0 L ${_vm.svgWidth},0 L ${_vm.svgWidth},${_vm.svgHeight} L 0,${_vm.svgHeight} z`}}),_c('path',{staticClass:"path2",attrs:{"pointer-events":"auto","d":`M ${_vm.mouseX - _vm.svgLeft},5
        L ${0},${_vm.svgHeight}
        L ${_vm.svgWidth},${_vm.svgHeight} z`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }